// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getAuth} from 'firebase/auth'
import {getFirestore} from 'firebase/firestore'
import {getStorage} from 'firebase/storage'
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// luismrosero1992@gmail.com
const firebaseConfig = {
    apiKey: "AIzaSyC-gkDsVyV5cFD9DD7bC1ETMKWAyoAoAWI",
    authDomain: "fundhap-f6ce2.firebaseapp.com",
    projectId: "fundhap-f6ce2",
    storageBucket: "fundhap-f6ce2.firebasestorage.app",
    messagingSenderId: "1046099553688",
    appId: "1:1046099553688:web:63edb6c062ce20dc590fed",
    measurementId: "G-T3EZG3B5T0"
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

export const auth = getAuth(app)
export const fire = getFirestore(app)
export const storage = getStorage(app)